import type { IRecordTypeDefinition } from '@platform/core/types';
import type { IAnalyticsFields } from './IAnalyticsFields';

/**
 * Поля аналітики типу запису (прототип v4 isDashboard): виконавець `assignee` (користувач), термін `due` (дата), пріоритет `priority`
 * (вибір), сума по відкритих — поле `remaining`, інакше перше числове поле типу (як remF прототипу: «Відкрито · Відносний пріоритет»).
 * Приховані поля лише для даних не враховуються (у полях модуля прототипу їх немає: пріоритет SLA). Чиста функція.
 */
export function analyticsFieldsOf(rt: IRecordTypeDefinition): IAnalyticsFields {
  const fields = rt.fields.filter((f) => !f.hidden);
  const has = (key: string, types: readonly string[]) => fields.some((f) => f.key === key && types.includes(f.type));
  const remaining = fields.find((f) => f.key === 'remaining' && f.type === 'number') ?? fields.find((f) => f.type === 'number');
  return {
    assignee: has('assignee', ['user']) ? 'assignee' : undefined,
    due: has('due', ['date']) ? 'due' : undefined,
    priority: has('priority', ['select']) ? 'priority' : undefined,
    remaining: remaining?.key,
  };
}
